const topics = [
  { tag: '动作大片', heat: '9.8', count: '3.2万', desc: '热血激战、视觉盛宴' },
  { tag: '悬疑推理', heat: '9.6', count: '2.8万', desc: '烧脑剧情、反转不断' },
  { tag: '科幻巨制', heat: '9.5', count: '2.5万', desc: '未来想象、视效震撼' },
  { tag: '喜剧佳作', heat: '9.3', count: '2.1万', desc: '爆笑解压、合家欢乐' },
  { tag: '高分纪录', heat: '9.7', count: '1.9万', desc: '真实力量、深度思考' },
  { tag: '经典重温', heat: '9.4', count: '2.6万', desc: '永恒佳作、百看不厌' },
  { tag: '日韩精选', heat: '9.2', count: '2.3万', desc: '细腻情感、独特风格' },
  { tag: '欧美热播', heat: '9.1', count: '3.0万', desc: '全球同步、热度爆表' },
  { tag: '国产精品', heat: '9.9', count: '3.8万', desc: '优质原创、文化共鸣' },
  { tag: '动画电影', heat: '9.0', count: '1.7万', desc: '创意无限、全龄共享' },
  { tag: '新片速递', heat: '9.6', count: '3.5万', desc: '第一时间、抢先体验' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            探索当前最受关注的影视话题，发现属于你的观影兴趣点
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
          {topics.slice(0, 11).map((item) => (
            <div
              key={item.tag}
              className="bg-background-50 rounded-xl p-4 text-center hover:bg-primary-50/50 transition-colors duration-200 cursor-pointer group"
            >
              <div className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors mb-1 whitespace-nowrap">
                #{item.tag}
              </div>
              <div className="flex items-center justify-center gap-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-fire-line text-accent-500 text-xs"></i>
                  {item.heat}
                </span>
                <span>{item.count}</span>
              </div>
              <div className="text-xs text-foreground-400 mt-1">{item.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}